import React, { Component } from 'react'
import PropTypes from 'prop-types'

import VendorPurchaseOrderBasicInfo from '../VendorPurchaseOrderBasicInfo'
import PurchaseOrderEditor from '../PurchaseOrderEditor'

import { actions as purchaseOrderActions } from '../../redux/modules/jobFunctions/purchaseOrderActions'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

import _ from 'lodash'

const propTypes = {
  selectedEstimateItems: PropTypes.object,

  // VendorPurchaseOrderBasicInfo
  basicInfoInputChange: PropTypes.func.isRequired,
  basicInfoDescription: PropTypes.string,
  terms: PropTypes.string,
  shipTo: PropTypes.string,
  attention: PropTypes.string,
  setVendorAdressForm: PropTypes.func.isRequired,

  // PurchaseOrderEditor
  purchaseOrderSections: PropTypes.array,
  purchaseOrderItems: PropTypes.array,
  onSectionNameChange: PropTypes.func.isRequired,
  addSection: PropTypes.func.isRequired,
  allItems: PropTypes.array.isRequired,
  moveSectionDown: PropTypes.func.isRequired,
  moveSectionUp: PropTypes.func.isRequired,
  moveItemUp: PropTypes.func.isRequired,
  moveItemDown: PropTypes.func.isRequired,
  deleteSection: PropTypes.func.isRequired,
  addItem: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  createNewItem: PropTypes.func.isRequired,
  updatePurchaseOrderSections: PropTypes.func.isRequired,
  updatePurchaseOrderItems: PropTypes.func.isRequired
}

class PurchaseOrderCreationStep2 extends Component {
  state = {
    estimateSelectedSections: [],
    estimateSelectedItems: []
  }

  componentDidMount() {
    const estimate = _.get(this.props, 'purchaseOrder.estimate.data')
    const {
      selectedEstimateItems,
      updatePurchaseOrderSections,
      updatePurchaseOrderItems
    } = this.props
    const { estimateSelectedSections, estimateSelectedItems } = this.state

    // define the items selected from estimate to mount the PO structure
    if (estimate && selectedEstimateItems) {
      estimate.sections.forEach((estimateSection, sectionIndex) => {
        // check if we have this section selected
        if (selectedEstimateItems[sectionIndex]) {
          const newEstimateSelectedSections = estimateSelectedSections

          // prevent add sections with items
          const selectedEstimateSection = { ...estimateSection }
          delete selectedEstimateSection.items

          newEstimateSelectedSections.push(selectedEstimateSection)
          this.setState(
            {
              estimateSelectedSections: newEstimateSelectedSections
            },
            updatePurchaseOrderSections(newEstimateSelectedSections)
          )
        }
        estimateSection.items.forEach((estimateItem, itemIndex) => {
          let foundItem = null
          if (selectedEstimateItems[sectionIndex]) {
            foundItem = _.find(
              selectedEstimateItems[sectionIndex],
              item => item.key === estimateItem.id
            )
          }

          if (foundItem) {
            const newEstimateSelectedItems = estimateSelectedItems

            newEstimateSelectedItems.push(estimateItem)
            this.setState(
              {
                estimateSelectedItems: newEstimateSelectedItems
              },
              updatePurchaseOrderItems(newEstimateSelectedItems)
            )
          }
        })
      })
    }
  }

  render() {
    const {
      basicInfoInputChange,
      basicInfoDescription,
      terms,
      shipTo,
      attention,
      setVendorAdressForm,
      purchaseOrderSections,
      purchaseOrderItems,
      onSectionNameChange,
      addSection,
      allItems,
      moveSectionDown,
      moveSectionUp,
      moveItemUp,
      moveItemDown,
      deleteSection,
      addItem,
      deleteItem,
      createNewItem
    } = this.props
    return (
      <div>
        <VendorPurchaseOrderBasicInfo
          basicInfoInputChange={basicInfoInputChange}
          description={basicInfoDescription}
          terms={terms}
          shipTo={shipTo}
          attention={attention}
          setVendorAdressForm={setVendorAdressForm}
        />
        <PurchaseOrderEditor
          purchaseOrderSections={purchaseOrderSections}
          purchaseOrderItems={purchaseOrderItems}
          onSectionNameChange={onSectionNameChange}
          addSection={addSection}
          allItems={allItems}
          moveSectionDown={moveSectionDown}
          moveSectionUp={moveSectionUp}
          moveItemUp={moveItemUp}
          moveItemDown={moveItemDown}
          deleteSection={deleteSection}
          addItem={addItem}
          deleteItem={deleteItem}
          createNewItem={createNewItem}
        />
      </div>
    )
  }
}

PurchaseOrderCreationStep2.propTypes = propTypes

const mapStateToProps = ({ purchaseOrder }, ownProps) => ({
  purchaseOrder
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, purchaseOrderActions), dispatch)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderCreationStep2))



// WEBPACK FOOTER //
// ./src/components/purchaseorders/PurchaseOrderCreationStep2.js